import React, { useState } from 'react'
import { ErrorMessage, Field, useFormikContext } from 'formik'
import CustomError from '../../CustomError'
import PassIcons from './PassIcons'

const PassField = ({ name, fieldClassName, placeholder, formik, t, isAccountInfo, showInfoIcon, autoComplete = 'off' }) => {
  const [toggleViewPassword, setToggleViewPassword] = useState(false)
  const { errors, touched } = useFormikContext()
  const hasError = errors[name] && touched[name]

  return (
    <div className='position-relative'>
      <Field
        id={name}
        name={name}
        type={toggleViewPassword ? 'text' : 'password'}
        className={`${fieldClassName || ''} ${hasError ? 'input-error' : ''}`.trim()}
        placeholder={placeholder}
        autoComplete={autoComplete}
      />
      <ErrorMessage name={name} component={CustomError} />
      <PassIcons toggleViewPassword={toggleViewPassword} setToggleViewPassword={setToggleViewPassword} />
    </div>
  )
}

export default PassField
